module.exports = __webpack_public_path__ + "img/Lasagna Meal-Spinach Feta.175a9e01.jpg";